import { React, useEffect, useState } from "react";
import ico_handy_orange from "../../../assets/icons/ico_handy_orange.svg";
import ico_huellas_green from "../../../assets/icons/ico_huellas_green.svg";
import ToolsInfoSection from "../../../components/toolsInfoSection";
import ToolsTab from "../../../components/toolsTab";
import VideoBanner from "../../../components/videoBanner";
import img_dron from "../../../assets/images/img_dron.png";
import GoToPage from "../../../components/goToPage";
import ToolsActivityButton from "../../../components/toolsActivityButton";

//solucion a problema de altura en linea 100
const DronesScreen = ({ handle }) => {
  const cielo = "5Ke8oY85S8M";
  const [width, setWidth] = useState(window.innerWidth);
  useEffect(() => {
    function handleResize() {
      setWidth(window.innerWidth);
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [width]);

  useEffect(() => {
    handle(false);
    return () => handle(true);
  }, [handle]);

  return (
    <div className="w-full bg-[#002E0F] h-full overflow-hidden">
     {width > 1279 ? (
     <div>
<div className="w-full lg:h-[1080px]  absolute">
        <VideoBanner idVideo={cielo}></VideoBanner>
      </div>
      <div className="w-full mx-auto text-white relative h-fit  ">
        <div className="absolute right-0 mt-[35rem] mr-[1rem]">
          <img loading="lazy"
          
          src={img_dron} 
          className="lg:w-[60rem] md:w-[20rem] sm:w-[20rem] w-[20rem] 2xl:visible xl:invisible lg:invisible md:invisible sm:visible visible"
          ></img>
        </div>

        <div className="justify-center text-black h-fit text-left pt-[14rem] relative lg:pl-[8rem] md:pl-[3rem] sm:pl-[3rem] pl-[3rem]">
         <GoToPage
                page="/herramientas"
                side="left"
                name="Atrás"
                fontSizeXL="xl:text-xl"
                fontSizeL="lg:text-lg"
                fontSizeM="md:text-lg"
                fontSizeS="sm:text-base"
                fontSize="text-base"
                textType="font-bold"
                textColor="text-black"
                borderType="border-b-2"
                borderColor="border-black"
                iconSize="h-5"
                iconColor=""
                iconMargin="mr-5"
              ></GoToPage>
        </div>
        <div className="grid mb-52 relative lg:pl-32 md:pl-20 sm:pl-10 pl-10 2xl:pr-0 xl:pr-[15rem] lg:pr-[20rem] md:pr-[5rem] sm:pr-[5rem] pr-[5rem] mr-80 2xl:grid-cols-5 xl:grid-cols-1 lg:grid:cols-1 md:grid-cols-1 sm:grid-cols-1 grid-cols-1 2xl:pb-[10rem] xl:pb-[70rem] lg:pb-[70rem] md:pb-[90rem] sm:pb-[90rem] pb-[90rem] min-w-[10rem] pt-10 w-full  ">
              <div className="xl:h-[58rem] col-span-2 lg:h-[75rem] md:h-[75rem] sm:h-full h-full text-black lg:mr-10 bg-white w-full z-10 relative   ">
            <ToolsInfoSection
              firstIcon={ico_handy_orange}
              secondIcon={ico_huellas_green}
              tag={
                <p>
                  Aves, mamíferos, plantas <br /> y ecosistemas
                </p>
              }
              title={
                <h1 className="lg:text-5xl md:text-2xl sm:text-2xl text-2xl lg:px-10 md:px-0 sm:px-0 px-0 lg:text-left md:text-center sm:text-center text-center font-bold  my-10  ">Drones</h1>
              }
              text={
                <p className="lg:px-10 md:px-0 sm:px-0 px-0 lg:text-xl md:text-xl sm:text-base text-base pb-5">

                   En los últimos 17 años los drones se han convertido en <b>un nueva herramienta de monitoreo aéreo de fauna silvestre</b>. Los drones son conocidos por la sigla <b>UAS (Unmanned Aircraft Sytems)</b> que significa que son aeronaves sin tripulación y autónomas. Existen gran variedad de tamaños y sus aplicaciones dependen del objetivo y por tanto de la definición de su “carga útil” , que consiste en un grupo de sensores: cámaras de fotos y/o video (en espectro visible, térmico o multiespectral), sensores meteorológicos o dispositivos para la toma de muestras.
                </p>
              }
            ></ToolsInfoSection>
          </div>
         
          <div className="relative col-span-3 2xl:mt-[50rem] xl:mt-[0rem] lg:mt-[0rem] md:mt-[0rem] sm:mt-[0rem] mt-[0rem]  items-center">
                
                 
              <div className="relative w-full h-full items-center  text-white bg-[#002E0F] pr-10 pt-5">
                <ToolsTab
                firstTitle="Sistemas productivos y naturales"
                secondTitle="Resultados y beneficios"
                  firstTab={
                    <p className="text-xl mb-5">
                      Los drones se han convertido en una herramienta asequible y rentable para mapear rápidamente un área específica, y para muchas aplicaciones emergentes en el ámbito del monitoreo de vida silvestre, ecológico y en zonas de difícil acceso.
                    </p>
                  }
                  secondTab={
                    <div>
                      <p className="text-xl mb-5">
                        Los drones permiten explorar lugares de muy difícil
                        acceso.
                      </p>
                      <p className="text-xl mb-5">
                        Permiten realizar fotografías y videos de gran
                        resolución con mucha frecuencia.
                      </p>
                      <p className="text-xl mb-5">
                      Permiten censar poblaciones de aves y mamíferos y ubicar nidos y madrigueras.
                      </p>
                    </div>
                  }
                ></ToolsTab>
              </div>
          </div>
        </div>
      </div>
     </div>
     ):(
     <div>

<div className="w-full absolute ">
            <VideoBanner idVideo={cielo}></VideoBanner>
            <div className=" absolute right-0 bottom-0 lg:mb-40 md:mb-32 sm:mb-20 mb-20">
              <img
              
                src={img_dron}
                className="lg:w-[35rem] md:w-[25rem] sm:w-[15rem] w-[15rem]"
              ></img>
            </div>
          </div>


          <div className="grid grid-cols-1 2xl:px-52  lg:px-30 md:px-10 sm:px-14 px-10 pb-[40rem]">
            <div className="justify-center text-black h-fit text-left lg:mt-[25rem] md:mt-[15rem] sm:mt-[7rem] mt-[7rem] relative ">
            <GoToPage
                page="/herramientas"
                side="left"
                name="Atrás"
                fontSizeXL="xl:text-xl"
                fontSizeL="lg:text-lg"
                fontSizeM="md:text-lg"
                fontSizeS="sm:text-base"
                fontSize="text-base"
                textType="font-bold"
                textColor="text-black"
                borderType="border-b-2"
                borderColor="border-black"
                iconSize="h-5"
                iconColor=""
                iconMargin="mr-5"
              ></GoToPage>
            </div>

            <div className=" h-fit text-black  bg-white w-full z-10 relative bottom-0  mt-[4rem]  ">
             
              <ToolsInfoSection
              firstIcon={ico_handy_orange}
              secondIcon={ico_huellas_green}
              tag={
                <p>
                  Aves, mamíferos, plantas <br /> y ecosistemas
                </p>
              }
              title={
                <h1 className="lg:text-5xl md:text-2xl sm:text-2xl text-2xl lg:px-10 md:px-0 sm:px-0 px-0 lg:text-left md:text-center sm:text-center text-center font-bold  my-10  ">Drones</h1>
              }
              text={
                <p className="lg:px-10 md:px-0 sm:px-0 px-0 lg:text-xl md:text-xl sm:text-base text-base lg:pb-40 md:pb-36 sm:pb-32 pb-32">
                          En los últimos 17 años los drones se han convertido en <b>un nueva herramienta de monitoreo aéreo de fauna silvestre</b>. Los drones son conocidos por la sigla <b>UAS (Unmanned Aircraft Sytems)</b> que significa que son aeronaves sin tripulación y autónomas. Existen gran variedad de tamaños y sus aplicaciones dependen del objetivo y por tanto de la definición de su “carga útil” , que consiste en un grupo de sensores: cámaras de fotos y/o video (en espectro visible, térmico o multiespectral), sensores meteorológicos o dispositivos para la toma de muestras.

                </p>
              }
            ></ToolsInfoSection>
            </div>
            <div className="relative w-full h-full items-center lg:mt-32 md:mt-10 sm:mt-5 mt-5  text-white bg-[#002E0F]">
            <ToolsTab
            firstTitle="Sistemas productivos y naturales"
            secondTitle="Resultados y beneficios"
                  firstTab={
                    <p className="lg:text-xl md:text-base sm:text-sm text-sm mb-5">
                     Los drones se han convertido en una herramienta asequible y rentable para mapear rápidamente un área específica, y para muchas aplicaciones emergentes en el ámbito del monitoreo de vida silvestre, ecológico y en zonas de difícil acceso.
                    </p>
                  }
                  secondTab={
                    <div>
                      <p className="lg:text-xl md:text-base sm:text-sm text-sm mb-5">
                        Los drones permiten explorar lugares de muy difícil
                        acceso.
                      </p>
                      <p className="lg:text-xl md:text-base sm:text-sm text-sm mb-5">
                        Permiten realizar fotografías y videos de gran
                        resolución con mucha frecuencia.
                      </p>
                      <p className="lg:text-xl md:text-base sm:text-sm text-sm mb-5">
                      Permiten censar poblaciones de aves y mamíferos y ubicar nidos y madrigueras.
                      </p>
                    </div>
                  }
                ></ToolsTab>
            </div>
          </div>

     </div>
     )}
     
      
    </div>
  );
};

export default DronesScreen;
